<template>
    <div class="container">
        <h1>Política de Privacidade — Plataforma Lummefy</h1>
        
        <p>A Innovare Soluções Inovadoras em Informática Ltda. ("Innovare", "nós") opera o site <a href="https://www.lummefy.com.br">https://www.lummefy.com.br</a> e fornece serviços digitais voltados para gestão de mentorias. Por meio desta política de privacidade, informamos a você quais dados pessoais coletamos, quando e como os processamos.</p>

        <h2>1. Identidade da Innovare</h2>
        <div class="company-info">
            <ul>
                <li><strong>Razão Social:</strong> Innovare Soluções Inovadoras em Informática Ltda.</li>
                <li><strong>CNPJ:</strong> 27.491.194/0001-21</li>
                <li><strong>Endereço:</strong> Rua Hilda Del Nero Bisquolo, 102, 20º andar, sala 2002 - Jardim Florida, Jundiaí – SP - The One Office Tower</li>
                <li><strong>E-mail:</strong> <a href="mailto:contato@lummefy.com.br">contato@lummefy.com.br</a></li>
            </ul>
        </div>

        <h2>2. Dados pessoais que coletamos</h2>
        <ul>
            <li><strong>Ao usar o site:</strong> endereço IP, dados de navegação, data e hora da conexão, navegador, provedor.</li>
            <li><strong>Ao se cadastrar:</strong> nome, sobrenome, e-mail, celular, CPF/CNPJ (quando aplicável).</li>
            <li><strong>Mentores e mentorados:</strong> dados inseridos no formulário de aplicação, agendamento de sessões, atividades e interações no chat.</li>
            <li><strong>Colaboradores da Innovare:</strong> dados necessários para operação interna.</li>
        </ul>

        <h2>3. Finalidades</h2>
        <ul>
            <li>Fornecer, operar e melhorar a plataforma de mentorias.</li>
            <li>Permitir comunicação entre mentor e mentorado.</li>
            <li>Cumprir obrigações legais e contratuais.</li>
            <li>Garantir a segurança e prevenir fraudes.</li>
        </ul>

        <h2>4. Compartilhamento</h2>
        <p>Internamente, apenas áreas responsáveis tratam dados. Externamente, podemos usar provedores de TI e serviços de hospedagem. Dados não são transferidos para fora do Brasil, exceto em caso de serviços de nuvem.</p>

        <h2>5. Armazenamento</h2>
        <ul>
            <li><strong>Logs:</strong> 28 dias.</li>
            <li><strong>Dados de conta:</strong> enquanto houver relação contratual.</li>
            <li>Após o término, dados podem ser anonimizados ou excluídos.</li>
        </ul>

        <h2>6. Direitos do titular (LGPD)</h2>
        <ul>
            <li>Acesso, retificação, exclusão, portabilidade, restrição e oposição.</li>
            <li>Retirada do consentimento a qualquer momento.</li>
            <li>Solicitações devem ser enviadas para <a href="mailto:contato@lummefy.com.br">contato@lummefy.com.br</a>.</li>
        </ul>

        <h2>7. Cookies</h2>
        <p>Utilizamos cookies para navegação, analytics e melhoria de experiência. O usuário pode desativá-los no navegador.</p>

        <h2>8. Google Analytics</h2>
        <p>Podemos utilizar Google Analytics, de forma anonimizada, para análise de uso da plataforma.</p>

        <h2>9. Integração com Google</h2>
        
        <h3>9.1 Dados Acessados</h3>
        <p>A Lummefy poderá acessar dados do Google estritamente necessários para o funcionamento das funcionalidades da plataforma, como:</p>
        <ul>
            <li><strong>Perfil básico do usuário Google:</strong> nome, e-mail e foto de perfil para autenticação via Google.</li>
            <li><strong>Google Calendar:</strong> criação, listagem e edição de eventos para permitir agendamento e sincronização de sessões entre mentor e mentorado.</li>
            <li><strong>Google Drive/Docs:</strong> upload, compartilhamento ou visualização de materiais da mentoria (quando aplicável).</li>
        </ul>

        <h3>9.2 Uso dos Dados</h3>
        <p>Os dados coletados são utilizados exclusivamente para:</p>
        <ul>
            <li>Autenticação segura e login rápido com conta Google.</li>
            <li>Sincronização de agenda entre mentor e mentorado.</li>
            <li>Compartilhamento de materiais quando solicitado pelo mentor.</li>
        </ul>
        <p><strong>Importante:</strong> Nenhum dado é utilizado para fins publicitários ou de marketing sem consentimento explícito.</p>

        <h3>9.3 Compartilhamento de Dados</h3>
        <ul>
            <li>A Lummefy não compartilha dados de usuários do Google com terceiros.</li>
            <li><strong>Exceção:</strong> provedores de hospedagem e serviços de nuvem que atuam como operadores de dados (subprocessadores), exclusivamente para o funcionamento da plataforma.</li>
            <li>Em nenhuma hipótese os dados são vendidos ou cedidos para fins comerciais.</li>
        </ul>

        <h3>9.4 Armazenamento e Proteção dos Dados</h3>
        <ul>
            <li>Dados armazenados em servidores seguros localizados no Brasil e/ou em provedores internacionais que seguem padrões de segurança como LGPD (Lei Geral de Proteção de Dados, Brasil).</li>
            <li>Criptografia em trânsito (TLS 1.2+) e criptografia em repouso (AES-256).</li>
            <li>Acesso restrito apenas a colaboradores autorizados, sob cláusulas de confidencialidade.</li>
        </ul>

        <h3>9.5 Retenção e Exclusão dos Dados</h3>
        <ul>
            <li>Dados de agenda, login e perfil são mantidos enquanto a conta estiver ativa.</li>
            <li>O usuário pode solicitar a exclusão de seus dados a qualquer momento, enviando e-mail para <a href="mailto:contato@lummefy.com.br">contato@lummefy.com.br</a>.</li>
            <li>Após o pedido, os dados serão removidos em até 30 dias corridos.</li>
            <li>Backups criptografados podem reter dados por até 90 dias, exclusivamente para recuperação de falhas técnicas, sendo excluídos automaticamente após esse período.</li>
        </ul>


        <div class="contact-info">
            <p><strong>Para dúvidas sobre esta política:</strong> Entre em contato conosco através do e-mail <a href="mailto:contato@lummefy.com.br">contato@lummefy.com.br</a></p>
        </div>

        <div class="last-updated">
            <p>Última atualização: Setembro de 2025</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PrivacyPolicy',
    data() {
        return {
            lastUpdate: 'Setembro de 2025'
        }
    }
}
</script>

<style scoped>
.content h2 {
    margin-top: 2rem;
    margin-bottom: 1rem;
    color: #333;
}

.content h3 {
    margin-top: 1.5rem;
    margin-bottom: 0.75rem;
    color: #444;
    font-size: 1.1em;
}

.content p {
    margin-bottom: 1rem;
    line-height: 1.6;
}

.content ul {
    margin-bottom: 1rem;
    padding-left: 2rem;
}

.content li {
    margin-bottom: 0.5rem;
}
</style>
